module.exports = __webpack_public_path__ + "assets/chargebee.9f2937b9.svg";